import * as React from 'react';
import {Flex, Text, Currency} from 'components/UIKit';
import styles from '../../ListingCard.scss';

interface Metric {
  label: string;
  frequency?: string;
  value: number;
}

interface CardMetricProps {
  metric: Metric;
}

export class CardMetric extends React.PureComponent<CardMetricProps> {
  render() {
    const {metric} = this.props;

    return (
      <Flex className={styles.metric}>
        <Flex wrapperComponent="dt" className={styles.metricLabelWrapper}>
          <Text className={styles.metricLabel} text={metric.label} type="smaller" resetMargin />
          {metric.frequency && (
            <Text
              type="smaller"
              secondary
              text={` /${metric.frequency}`}
              component="p"
              resetMargin
            />
          )}
        </Flex>
        <dd className={styles.noMargin}>
          {metric.value ? (
            <Currency
              value={metric.value}
              className={styles.metricValue}
              display={null}
              condensed
            />
          ) : (
            <p className={styles.metricValue}>—</p>
          )}
        </dd>
      </Flex>
    );
  }
}
